// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../../styles/scrollbars.module.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AOzhZ2rZPDVAh3cdh8N3 {
  display: flex;
  flex-direction: column;
  min-height: 0;
  background: #fff;
}

.dJAg7gYellJEmBlG9iVi {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  min-height: 36px;
  padding: 0 16px;
  background: #f8f8f8;
  border-bottom: 1px solid #ebebeb;
}

.lhOD3MQih7dEKckHnv4l {
  color: #888;
  font-size: 11px;
}

.ovXq5n0oidyHWVNwt0bf {
  overflow: auto;
}

.hmn6lIompM9IWaF4HWU7 {
  opacity: 0.55;
  pointer-events: none;
  transition: opacity 0.15s ease;
}

.LTXUKZjqaNAzRQGtKgJT {
  width: 100%;
  border-collapse: collapse;
  font-family: "Fira Code", "Courier New", monospace;
  font-size: 12px;
}

.LTXUKZjqaNAzRQGtKgJT thead tr {
  background: #f0f0f0;
  border-bottom: 1px solid #e0e0e0;
}

.LTXUKZjqaNAzRQGtKgJT th {
  padding: 8px 14px;
  color: #999;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: lowercase;
  text-align: left;
  white-space: nowrap;
  border-right: 1px solid #e0e0e0;
}

.LTXUKZjqaNAzRQGtKgJT th:last-child {
  border-right: 0;
}

.LTXUKZjqaNAzRQGtKgJT td {
  padding: 10px 14px;
  border-bottom: 1px solid #ebebeb;
  border-right: 1px solid #f0f0f0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 220px;
}

.LTXUKZjqaNAzRQGtKgJT td:last-child {
  border-right: 0;
}

.uOLZ97bmHlsBTEggqEaj {
  background: rgba(16, 185, 129, 0.04);
}

.Je4Tr3Y2PhN830NK6qxH {
  color: #3b6fd4;
}

.W67pCM0zyDLmY2uPgM8a {
  color: #2f8f4a;
}

.gHzVlO5lvo0L3B0GXguz {
  color: #1e1f23;
}

.N8cjAI9t0EpNqHnm4fv0 {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  min-height: 42px;
  padding: 0 16px;
  background: #fafafa;
  border-top: 1px solid #ebebeb;
}

.TVoLtVStInnKZMi3utJL {
  color: #888;
  font-size: 11px;
}

.qA2FjI2tnmHExvUscyU3 {
  display: flex;
  align-items: center;
  gap: 6px;
}

.XU4HHnTGkA4pY8gAA_vg {
  min-width: 22px;
  height: 20px;
  border: 1px solid #ebebeb;
  border-radius: 4px;
  background: #fff;
  color: #888;
  font-size: 11px;
  line-height: 1;
  cursor: pointer;
  padding: 0 6px;
}

.XU4HHnTGkA4pY8gAA_vg:hover:not(:disabled) {
  border-color: #d0d0d0;
  color: #555;
}

.XU4HHnTGkA4pY8gAA_vg:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

.kXLn0HB_KqzpX9R5FMgq {
  background: #1e1f23;
  border-color: #1e1f23;
  color: #fff;
}

.yBiivehtwA0vxyLWVTMn,
.nQKlkz5UOthLnBJMKLx1,
.bfZfZL04lFZYRrnVFMYs {
  padding: 24px 16px;
  color: #85868b;
  font-size: 12px;
}

.nQKlkz5UOthLnBJMKLx1 {
  color: #9f3f3f;
}

.bfZfZL04lFZYRrnVFMYs {
  border-top: 1px solid #ebebeb;
}

.mI7lw4g9eDEGgYIg94N8 {
  padding: 8px 16px 12px;
  color: #9f3f3f;
  font-size: 11px;
  background: #fff6f4;
  border-top: 1px solid #ecc8c0;
}
`, "",{"version":3,"sources":["webpack://./src/components/datasets/catalog/DatasetTablePreview.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EAEE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,kDAAkD;EAClD,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,+BAA+B;EAC/B,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;AACb;;AAEA;;;EAGE,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,sBAAsB;EACtB,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,6BAA6B;AAC/B","sourcesContent":[".panel {\n  display: flex;\n  flex-direction: column;\n  min-height: 0;\n  background: #fff;\n}\n\n.toolbar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  min-height: 36px;\n  padding: 0 16px;\n  background: #f8f8f8;\n  border-bottom: 1px solid #ebebeb;\n}\n\n.toolbarNote {\n  color: #888;\n  font-size: 11px;\n}\n\n.tableWrap {\n  composes: thinScrollbar from \"../../../styles/scrollbars.module.css\";\n  overflow: auto;\n}\n\n.tableRefreshing {\n  opacity: 0.55;\n  pointer-events: none;\n  transition: opacity 0.15s ease;\n}\n\n.table {\n  width: 100%;\n  border-collapse: collapse;\n  font-family: \"Fira Code\", \"Courier New\", monospace;\n  font-size: 12px;\n}\n\n.table thead tr {\n  background: #f0f0f0;\n  border-bottom: 1px solid #e0e0e0;\n}\n\n.table th {\n  padding: 8px 14px;\n  color: #999;\n  font-size: 10px;\n  font-weight: 700;\n  letter-spacing: 0.06em;\n  text-transform: lowercase;\n  text-align: left;\n  white-space: nowrap;\n  border-right: 1px solid #e0e0e0;\n}\n\n.table th:last-child {\n  border-right: 0;\n}\n\n.table td {\n  padding: 10px 14px;\n  border-bottom: 1px solid #ebebeb;\n  border-right: 1px solid #f0f0f0;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  max-width: 220px;\n}\n\n.table td:last-child {\n  border-right: 0;\n}\n\n.rowTint {\n  background: rgba(16, 185, 129, 0.04);\n}\n\n.cellId {\n  color: #3b6fd4;\n}\n\n.cellNumber {\n  color: #2f8f4a;\n}\n\n.cellText {\n  color: #1e1f23;\n}\n\n.pagination {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  min-height: 42px;\n  padding: 0 16px;\n  background: #fafafa;\n  border-top: 1px solid #ebebeb;\n}\n\n.paginationNote {\n  color: #888;\n  font-size: 11px;\n}\n\n.paginationControls {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.pageButton {\n  min-width: 22px;\n  height: 20px;\n  border: 1px solid #ebebeb;\n  border-radius: 4px;\n  background: #fff;\n  color: #888;\n  font-size: 11px;\n  line-height: 1;\n  cursor: pointer;\n  padding: 0 6px;\n}\n\n.pageButton:hover:not(:disabled) {\n  border-color: #d0d0d0;\n  color: #555;\n}\n\n.pageButton:disabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n}\n\n.pageButtonActive {\n  background: #1e1f23;\n  border-color: #1e1f23;\n  color: #fff;\n}\n\n.state,\n.stateError,\n.emptyRows {\n  padding: 24px 16px;\n  color: #85868b;\n  font-size: 12px;\n}\n\n.stateError {\n  color: #9f3f3f;\n}\n\n.emptyRows {\n  border-top: 1px solid #ebebeb;\n}\n\n.inlineError {\n  padding: 8px 16px 12px;\n  color: #9f3f3f;\n  font-size: 11px;\n  background: #fff6f4;\n  border-top: 1px solid #ecc8c0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"panel": `AOzhZ2rZPDVAh3cdh8N3`,
	"toolbar": `dJAg7gYellJEmBlG9iVi`,
	"toolbarNote": `lhOD3MQih7dEKckHnv4l`,
	"tableWrap": `ovXq5n0oidyHWVNwt0bf ${___CSS_LOADER_ICSS_IMPORT_0___.locals["thinScrollbar"]}`,
	"tableRefreshing": `hmn6lIompM9IWaF4HWU7`,
	"table": `LTXUKZjqaNAzRQGtKgJT`,
	"rowTint": `uOLZ97bmHlsBTEggqEaj`,
	"cellId": `Je4Tr3Y2PhN830NK6qxH`,
	"cellNumber": `W67pCM0zyDLmY2uPgM8a`,
	"cellText": `gHzVlO5lvo0L3B0GXguz`,
	"pagination": `N8cjAI9t0EpNqHnm4fv0`,
	"paginationNote": `TVoLtVStInnKZMi3utJL`,
	"paginationControls": `qA2FjI2tnmHExvUscyU3`,
	"pageButton": `XU4HHnTGkA4pY8gAA_vg`,
	"pageButtonActive": `kXLn0HB_KqzpX9R5FMgq`,
	"state": `yBiivehtwA0vxyLWVTMn`,
	"stateError": `nQKlkz5UOthLnBJMKLx1`,
	"emptyRows": `bfZfZL04lFZYRrnVFMYs`,
	"inlineError": `mI7lw4g9eDEGgYIg94N8`
};
export default ___CSS_LOADER_EXPORT___;
